export default __webpack_public_path__ + "033f19459dc14e9b1cddd2f29e919f41.webm";